import React from 'react';
import OrdersPage from './OrdersPage';

const OrdersShopifyPage: React.FC = () => {
  return (
    <OrdersPage
      fixedSource="shopify"
      initialStatusGroup="completed"
      title="Orders"
      subtitle="Unified order view filtered to Shopify"
      cardTitle="Shopify Orders"
    />
  );
};

export default OrdersShopifyPage;
